<div class="no-compatible-main-outer1 card my-4">
    <div class="no-compatible-wrapper">
        <div class="card-img-top no-devices-image"></div>
        <h2 class="no-compatible-heading card-header" i18n="@@noCompatiblStepDeviceFound">
            No Compatible Devices Found
        </h2>
        <div class="card-body">
            <p i18n="@@noCompatiblDesc">Please set up your device using your Lorex app to the same email
                address and verify the following:</p>
            <ul class="no-compatible-ul">
                <li>
                <span i18n="@@noCompatiblStepOneDesc">
                    You are logged into the same account that you use for the Lorex app.
                </span>
                </li>
                <li>
            <span i18n="@@noCompatiblStepTwoDesc">
                You have <a href="https://www.lorex.com/pages/lorex-cloud-subscriptions#faqs" target="_blank">compatible devices</a> attached to your account.
            </span>
                </li>
                <li>
                <span i18n="@@noCompatiblStepThreeDesc">
          The device is updated to the latest firmware. To check firmware version navigate to "Device Settings" in the Lorex App and tap on "Firmware".
        </span>
                </li>
            </ul>
        </div>
    </div>
</div>